/**
 * Mapping of Indonesian license plate prefixes to their regions.
 */
export const PLATE_REGIONS: Record<string, string> = {
  A: 'Banten',
  B: 'Jakarta, Depok, Tangerang, Bekasi',
  D: 'Bandung, Cimahi',
  E: 'Cirebon, Indramayu, Majalengka, Kuningan',
  F: 'Bogor, Cianjur, Sukabumi',
  G: 'Pekalongan, Pemalang, Batang, Tegal, Brebes',
  H: 'Semarang, Salatiga, Kendal, Demak',
  K: 'Pati, Kudus, Jepara, Rembang, Blora, Grobogan',
  L: 'Surabaya',
  M: 'Madura',
  N: 'Malang, Probolinggo, Pasuruan, Lumajang, Batu',
  P: 'Besuki, Bondowoso, Situbondo, Jember, Banyuwangi',
  R: 'Banyumas, Cilacap, Purbalinggo, Banjarnegara',
  S: 'Bojonegoro, Tuban, Lamongan, Jombang, Mojokerto',
  T: 'Purwakarta, Subang, Karawang',
  AA: 'Kedu, Magelang, Purworejo, Kebumen, Temanggung, Wonosobo',
  AB: 'Yogyakarta',
  AD: 'Surakarta, Boyolali, Sukoharjo, Karanganyar, Wonogiri, Sragen, Klaten',
  AE: 'Madiun, Ngawi, Magetan, Ponorogo, Pacitan',
  AG: 'Kediri, Blitar, Tulungagung, Nganjuk, Trenggalek',
  BA: 'Sumatera Barat',
  BB: 'Sumatera Utara (Pantai Barat)',
  BD: 'Bengkulu',
  BE: 'Lampung',
  BG: 'Sumatera Selatan',
  BH: 'Jambi',
  BK: 'Sumatera Utara (Pantai Timur)',
  BL: 'Aceh',
  BM: 'Riau',
  BN: 'Kepulauan Bangka Belitung',
  BP: 'Kepulauan Riau',
  DA: 'Kalimantan Selatan',
  DB: 'Sulawesi Utara (Daratan)',
  DC: 'Sulawesi Barat',
  DD: 'Sulawesi Selatan (Selatan)',
  DE: 'Maluku',
  DF: 'Timor Timur (Historical)',
  DG: 'Maluku Utara',
  DH: 'NTT (Timor)',
  DK: 'Bali',
  DL: 'Sulawesi Utara (Kepulauan)',
  DM: 'Gorontalo',
  DN: 'Sulawesi Tengah',
  DP: 'Sulawesi Selatan (Utara)',
  DR: 'NTB (Lombok)',
  DS: 'Papua',
  DT: 'Sulawesi Tenggara',
  EA: 'NTB (Sumbawa)',
  EB: 'NTT (Flores)',
  ED: 'NTT (Sumba)',
  KB: 'Kalimantan Barat',
  KH: 'Kalimantan Tengah',
  KT: 'Kalimantan Timur',
  KU: 'Kalimantan Utara',
  PA: 'Papua',
  PB: 'Papua Barat',
};
